module.exports = __webpack_public_path__ + "img/personal-details.1f3ee506.svg";